
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.188 4c-1.985 0-3.82.672-5.125 1.906C10.758 7.141 10 8.926 10 11c0 1.688.52 3.004 1 4.281A4.464 4.464 0 009.5 15 4.516 4.516 0 005 19.5C5 21.973 7.027 24 9.5 24c2.3 0 4.184-1.762 4.438-4H14c0-.129.004-.25 0-.375V19.5c0-.098-.023-.188-.031-.281v-.032c-.012-.203-.043-.402-.063-.593-.168-1.567-.574-2.813-.969-3.875C12.43 13.355 12 12.309 12 11c0-1.594.54-2.805 1.438-3.656C14.335 6.492 15.645 6 17.188 6c1.542 0 2.687.48 3.5 1.313C21.5 8.145 22 9.374 22 11c0 1.469-.895 3.152-1.906 5.156C19.082 18.16 18 20.516 18 23.344 18 25.894 19.938 28 22.469 28c1.25 0 2.426-.48 3.25-1.375C26.543 25.73 27 24.453 27 23h-2c0 1.047-.309 1.77-.75 2.25s-1.031.75-1.781.75C21 26 20 24.95 20 23.344c0-2.309.918-4.32 1.906-6.282C22.895 15.102 24 13.195 24 11c0-2.043-.656-3.813-1.875-5.063C20.906 4.688 19.172 4 17.187 4zM9.5 17a2.475 2.475 0 012.469 2.219c.008.133-.004.265 0 .406C11.902 20.953 10.848 22 9.5 22 8.11 22 7 20.89 7 19.5S8.11 17 9.5 17z"}})])
          )
        }
      }
    